import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../providers/ApiProvider';

export function useSingleMarketingCampaign({
  code = '',
  enabled = true,
}: {
  code: string;
  enabled?: boolean;
}) {
  const api = useApi();

  return useQuery({
    queryKey: ['marketing-campaigns', code],
    queryFn: async () => {
      const res = await api.GET({
        endpoint: `marketing-campaigns/${code}`,
      });
      return res;
    },
    enabled,
  });
}
